///<amd-module name="typeahead/core/logging/FlightOriginPopulationLogger" />

import {FlightOriginPopulationMetric} from "typeahead/core/logging/FlightOriginPopulationMetric";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {FlightOriginPopulationMessage} from "typeahead/core/message/FlightOriginPopulationMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Lob, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class FlightOriginPopulationLogger {

    private populatedOrigin: string;
    private submittedOrigin: string;
    private latitude: string;
    private longitude: string;

    constructor() {
        this.populatedOrigin = "";
        this.submittedOrigin = "";
        this.latitude = "";
        this.longitude = "";

        // Akamai Population
        TypeaheadMessage.subscribe(
            FlightOriginPopulationMessage.getTopic(), (topic: string, message: FlightOriginPopulationMessage) => {
                this.populatedOrigin = message.getPopulatedOrigin();
                this.submittedOrigin = message.getPopulatedOrigin();
                this.latitude = message.getLatitude();
                this.longitude = message.getLongitude();
            },
        );

        // Suggestion selected
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(), (topic: string, message: SuggestionSelectedMessage) => {
                if (message.getDomElementId() && message.getDomElementId().indexOf("flight-origin") !== -1) {
                    this.submittedOrigin = message.getSuggestion().getLastSearchName().orElse("");
                }
            },
        );

        // Input changed
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), (topic: string, message: InputValueEditedMessage) => {
                if (message.getDomElementId() && message.getDomElementId().indexOf("flight-origin") !== -1) {
                    this.submittedOrigin = message.getNewInputValue();
                }
            },
        );

        // Wizard submitted
        TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(), (topic: string, message: SubmitClickedMessage) => {
                if (TypeaheadUtils.getLob() === Lob.Flight) {
                    this.emitOriginPopulationMetric();
                }
            },
        );
    }

    private emitOriginPopulationMetric(): void {
        if (!this.populatedOrigin) {
            return;
        }
        TypeaheadErrorLogger.log(undefined, undefined, ProblemOrigin.FlightOriginLogging,
            new FlightOriginPopulationMetric(
                this.populatedOrigin, this.submittedOrigin, this.latitude, this.longitude,
            ));
    }
}
